module.exports = __webpack_public_path__ + "img/blog-1.jpg?7dda872bc277ba6a32dc6133a2785ff4";